import { Spinner, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { useApp, useTranslatedTag } from "@next-platform/client-common-core";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { SearchClientCharacterListing } from "@/components";
import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import Trans from "@/components/Trans/Trans";
import { tagNameToUrlSlug } from "@/utils/tagUrlSlug";

import NotFoundPage from "../NotFound/NotFound";

export function ChatbotTag() {
  const { getTranslatedTag } = useTranslatedTag();
  const { tagId } = useParams<{ tagId: string }>();
  const { tagOptions, isLoading } = useApp();
  const resolvedTag = useMemo(() => {
    if (!tagId || !tagOptions || tagOptions.length === 0) return null;

    const tagIdSlug = tagNameToUrlSlug(tagId);

    return tagOptions.find((tag: string) => tagNameToUrlSlug(tag) === tagIdSlug) ?? null;
  }, [tagId, tagOptions]);

  const tagDisplay = resolvedTag ? getTranslatedTag(resolvedTag) : "";

  const metaProperties = useMemo(
    () => ({
      tag: tagDisplay,
    }),
    [tagDisplay],
  );

  if (isLoading) {
    return <Spinner />;
  }

  if (!resolvedTag) {
    return <NotFoundPage />;
  }

  return (
    <>
      <PageStaticMetaTags pageId="chatbotTag" properties={metaProperties} />
      <div className="ml-4 md:max-w-[600px]">
        <Text as="h1" variant={TextVariants.MOBILE_HEADING_4_BOLD}>
          <Trans i18nKey="common:chatbotTag.title" values={{ tag: tagDisplay }} />
        </Text>
        <Text variant={TextVariants.LABEL_SMALL_REGULAR}>
          <Trans i18nKey="common:chatbotTag.description" values={{ tag: tagDisplay }} />
        </Text>
      </div>
      <SearchClientCharacterListing defaultTag={resolvedTag} defaultSortField="rating_score:desc" />
    </>
  );
}
